import React from 'react';
import { QuoteIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
import { Eyebrow, Mark, SectionTitle } from './ui/Section';
export function Testimonials() {
  return <section className="bg-white px-4 py-14 md:py-20" data-id="element-222" data-mp="3fz5mltnqbceo">
      <div className="mx-auto max-w-6xl" data-id="element-223" data-mp="3fxksu698nxhv">
        <Eyebrow data-id="element-224" data-mp="3b143x9u7tf3q">From coaches using the system</Eyebrow>
        <SectionTitle data-id="element-225" data-mp="3ayhz3hypldp7">
          What coaches say about <Mark data-id="element-226" data-mp="36z96whjbhnvr">teaching with a complete system</Mark>
        </SectionTitle>

        <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-6" data-id="element-227" data-mp="32060asnov9lo">
          {testimonials.map((item, index) => <figure key={item.name} className={`flex flex-col rounded-2xl border border-charcoal/10 bg-ivory p-6 ${index < 3 ? 'lg:col-span-2' : 'lg:col-span-3'}`} data-id="element-228" data-mp="2x006b5ty5b0f" data-mpi={index}>
              <QuoteIcon className="h-7 w-7 text-gold-ink" aria-hidden="true" data-id="element-229" data-mp="v8dkrjstq8bc" />
              <p className="mt-3 font-display text-base font-black uppercase leading-snug text-charcoal" data-id="element-230" data-mp="q9tzzmpyv2kk">
                {item.headline}
              </p>
              <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-charcoal/80" data-id="element-231" data-mp="h817no7u2gkh">
                “{item.quote}”
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-charcoal/10 pt-4" data-id="element-232" data-mp="78k3xcc56cr5">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-forest font-display text-sm font-black text-ivory" data-id="element-233" data-mp="c624aec3fjnj">
                  {item.initials}
                </span>
                <span data-id="element-234" data-mp="14uhg6rzxhlun">
                  <span className="block text-sm font-extrabold text-charcoal" data-id="element-235" data-mp="14ur7ciwplz1x">
                    {item.name}, {item.age}
                  </span>
                  <span className="block text-xs text-charcoal/65" data-id="element-236" data-mp="v57mx8tclx4y">
                    {item.role} · {item.location}
                  </span>
                </span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}